// Горната лента на редизайнатите страници: (бутон „☰" на тесен екран) ·
// надзаглавие („Справка") · заглавие 22/700 · мета-текст ПОД него · действия
// вдясно. Операциите и справките в склада я ползват еднакво.
import type { ReactNode } from "react";
import { LeftOutlined, MenuOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useInventoryShell } from "../shell/InventoryShellContext";

type Props = {
  title: ReactNode;
  // „Справка" над заглавието — различава прегледа от операцията
  kicker?: string;
  subtitle?: ReactNode;
  // „← Доставка" над заглавието (редактор, отворен от начален екран)
  back?: { label: string; onClick: () => void };
  // Нещо до заглавието (тип документ, статус)
  titleAddon?: ReactNode;
  right?: ReactNode;
};

export const PageHeader = ({
  title,
  kicker,
  subtitle,
  back,
  titleAddon,
  right,
}: Props) => {
  const { t } = useTranslation();
  const { isMenuButtonVisible, openMenu, isNarrow } = useInventoryShell();
  return (
    <header
      className={`flex shrink-0 flex-wrap items-center gap-x-3.5 gap-y-2.5 border-b border-shade-2 bg-canvas ${
        isNarrow ? "px-4 py-3" : "px-7 py-4"
      }`}
    >
      {isMenuButtonVisible && (
        <button
          type="button"
          onClick={openMenu}
          aria-label={t("inventoryPage.openMenu")}
          className="flex h-[34px] w-[34px] shrink-0 cursor-pointer items-center justify-center rounded-lg border border-shade-3 bg-surface text-ink"
        >
          <MenuOutlined className="text-base" />
        </button>
      )}
      <div className="flex min-w-0 flex-col gap-0.5">
        {back && (
          <button
            type="button"
            onClick={back.onClick}
            className="mb-1 flex cursor-pointer items-center gap-1.5 self-start border-none bg-transparent p-0 text-[13px] leading-[normal] text-body hover:text-ink"
          >
            <LeftOutlined className="text-[11px]" />
            {back.label}
          </button>
        )}
        {kicker && (
          <span className="text-[11px] font-semibold uppercase leading-[normal] tracking-[0.12em] text-muted">
            {kicker}
          </span>
        )}
        <div className="flex min-w-0 flex-wrap items-center gap-2.5">
          {titleAddon}
          <h1
            className={`m-0 truncate font-bold leading-[1.2] tracking-[-0.01em] text-ink ${
              isNarrow ? "text-lg" : "text-[22px]"
            }`}
          >
            {title}
          </h1>
        </div>
        {subtitle && (
          <span className="text-[13.5px] leading-[1.35] text-body">{subtitle}</span>
        )}
      </div>
      {right && (
        <div
          className={`flex flex-wrap items-center gap-2.5 ${
            isNarrow ? "w-full" : "ml-auto"
          }`}
        >
          {right}
        </div>
      )}
    </header>
  );
};

export default PageHeader;
